import BaseProxy from './BaseProxy';

class Auth extends BaseProxy {
    constructor(parameters = {}) {
        super('/api/v1/courses', parameters);
    }

    async getAll(params = null) {
        return this.submit('get', '/all', params);
    }

    async updateCourseStatus(id, params = {}) {
        return this.submit('post', `/update/status/${id}`, params);
    }

    async assignStudent(params = {}) {
        return this.submit('post', '/assign', params);
    }

    async reassignStudent(params = {}) {
        return this.submit('post', '/reassign', params);
    }

    async trackProgress(id) {
        return this.submit('get', `/track/${id}`);
    }
}

export default Auth;



// WEBPACK FOOTER //
// ./src/api/Course.js